<onsip-header-main>
  <onsip-header-page-title>Voicemail Setup</onsip-header-page-title>
</onsip-header-main>
<div class="mat-body-2">{{ pricingText }}</div>
<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="voicemailFormGroup"
    onsipFormTracking
    name="admin-voicemail-setup-wizard"
    id="admin-voicemail-setup-wizard"
    (ngSubmit)="submit()"
  >
    <mat-horizontal-stepper
      #stepper
      linear
      class="onsip-stepper-disabled-header onsip-header-full-width"
    >
      <mat-step #basicStep completed="false">
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>Basic settings</span>
          }
        </ng-template>
        <div class="mat-headline-5">Basic settings</div>
        <ng-template *ngTemplateOutlet="voicemailBasicForm"></ng-template>
        <span class="navigation-buttons no-back">
          <button
            mat-button
            type="button"
            color="primary"
            class="cancel-button"
            (click)="handleCancel()"
          >
            Cancel
          </button>
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="nextStep()"
            [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_GO_TO_GREETING_STEP"
          >
            Next
          </button>
        </span>
      </mat-step>
      <mat-step #greetingStep completed="false">
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>Custom greetings</span>
          }
        </ng-template>
        <div class="mat-headline-5">Custom greeting (optional)</div>
        <ng-template *ngTemplateOutlet="voicemailGreetingForm"></ng-template>
        @if ((mobileBreakpoint | async) === false) {
        <div class="navigation-buttons">
          <button type="button" mat-stroked-button color="primary" (click)="backStep()">
            Back
          </button>
          <span>
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button"
              (click)="handleCancel()"
            >
              Cancel
            </button>
            <button
              type="button"
              mat-flat-button
              color="primary"
              (click)="nextStep()"
              [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_GO_TO_ADVANCED_SETTINGS_STEP"
            >
              Next
            </button>
          </span>
        </div>
        } @if (mobileBreakpoint | async) {
        <div class="navigation-mobile-buttons">
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="nextStep()"
            [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_GO_TO_ADVANCED_SETTINGS_STEP"
          >
            Next
          </button>
          <button type="button" mat-stroked-button color="primary" (click)="backStep()">
            Back
          </button>
          <button mat-button type="button" color="primary" (click)="handleCancel()">Cancel</button>
        </div>
        }
      </mat-step>
      <mat-step #advancedStep completed="false">
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>Advanced settings</span>
          }
        </ng-template>
        <div class="mat-headline-5">Advanced settings (optional)</div>
        <ng-template *ngTemplateOutlet="voicemailAdvancedForm"></ng-template>
        @if ((mobileBreakpoint | async) === false) {
        <div class="navigation-buttons">
          <button type="button" mat-stroked-button color="primary" (click)="backStep()">
            Back
          </button>
          <span>
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button"
              (click)="handleCancel()"
            >
              Cancel
            </button>
            <button
              type="button"
              mat-flat-button
              color="primary"
              (click)="nextStep()"
              [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_GO_REVIEW"
            >
              Next
            </button>
          </span>
        </div>
        } @if (mobileBreakpoint | async) {
        <div class="navigation-mobile-buttons">
          <button
            type="button"
            mat-flat-button
            color="primary"
            (click)="nextStep()"
            [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_GO_REVIEW"
          >
            Next
          </button>
          <button type="button" mat-stroked-button color="primary" (click)="backStep()">
            Back
          </button>
          <button mat-button type="button" color="primary" (click)="handleCancel()">Cancel</button>
        </div>
        }
      </mat-step>
      <mat-step #reviewStep>
        <ng-template matStepLabel>
          @if ((lessThanMediumBreakpoint | async) === false) {
          <span>Review</span>
          }
        </ng-template>
        <span class="review-header">
          <div class="mat-headline-5">Review</div>
          <button type="button" mat-stroked-button color="primary" (click)="toggleEditPanel()">
            {{ showEditPanel ? "Cancel edits" : "Edit info" }}
          </button>
        </span>
        <div class="review-container onsip-grid-placement">
          <div class="first-column">
            <div class="mat-headline-6">Basic settings</div>
            @if (!showEditPanel) {
            <div class="voicemail-basic-view-container">
              <section class="mailbox-owner">
                <div class="mat-body-1 m-b-12">Mailbox owner</div>
                <div>{{ getOwnerDisplayName() }}</div>
              </section>
              <section class="mailbox-name">
                <div class="mat-body-1 m-b-12">Mailbox name</div>
                <div [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_REVIEW_MAILBOX_NAME">
                  {{ voicemailFormGroup.controls.mailboxName.value || "n/a" }}
                </div>
              </section>
              <section class="mailbox-number">
                <div class="mat-body-1 m-b-12">Mailbox number</div>
                <div [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_REVIEW_MAILBOX_NUMBER">
                  {{ voicemailFormGroup.controls.mailboxNumber.value || "n/a" }}
                </div>
              </section>
              <section class="notification-email">
                <div class="mat-body-1 m-b-12">Notification email</div>
                <div>{{ voicemailFormGroup.controls.notificationEmail.value || "none" }}</div>
              </section>
              <section class="attach-as-wav">
                <div class="mat-body-1 m-b-12">Attach message as a .wav file</div>
                <div>{{ voicemailFormGroup.controls.attachAsWav.value ? "Yes" : "No" }}</div>
              </section>
              <section class="delete-after-sending">
                <div class="mat-body-1 m-b-12">Delete message after sending</div>
                <div>{{ voicemailFormGroup.controls.deleteAfterSending.value ? "Yes" : "No" }}</div>
              </section>
              <section class="mwi">
                <div class="mat-body-1 m-b-12">Message waiting notification</div>
                <div>{{ getMwiDisplayName() }}</div>
              </section>
              <section class="greetings">
                <div class="mat-body-1 m-b-12">Custom greeting</div>
                @if (!voicemailFormGroup.controls.greeting.value) {
                <div>
                  <div>This Voicemail box has no custom greeting.</div>
                  <div>
                    Click Edit Info button to upload a pre-recorded file (wav) or record a greeting
                    here.
                  </div>
                </div>
                } @if (voicemailFormGroup.controls.greeting.value && displayAudioFile) {
                <div class="voicemail-greetings-audio-container">
                  <audio
                    class="voicemail-greetings-audio"
                    controls
                    controlsList="nodownload"
                    [src]="displayAudioFile ? displayAudioFile : ''"
                  ></audio>
                  <a
                    id="admin-voicemail-greeting-{{ voicemailFormGroup.controls.greeting.value }}"
                    [href]="displayAudioFile ? displayAudioFile : ''"
                    download
                    type="audio/wav"
                  >
                    <mat-icon class="voicemail-download-icon" aria-label="download_greetings"
                      >get_app</mat-icon
                    >
                  </a>
                </div>
                }
              </section>
            </div>
            } @if (showEditPanel) {
            <ng-template
              *ngTemplateOutlet="voicemailBasicForm; context: { $implicit: 'one-column' }"
            ></ng-template>
            <div class="mat-body-1 m-b-12">Custom greeting</div>
            <ng-template
              *ngTemplateOutlet="voicemailGreetingForm; context: { $implicit: 'one-column' }"
            ></ng-template>
            }
          </div>
          <div class="second-column" [ngClass]="{ edit: showEditPanel }">
            <div class="mat-headline-6">Advanced settings (optional)</div>
            @if (!showEditPanel) {
            <div class="voicemail-advanced-view-container">
              <div class="first-column">
                <section class="time-zone">
                  <div class="mat-body-1 m-b-12">Time zone</div>
                  <div>{{ voicemailFormGroup.controls.timezone.value }}</div>
                </section>
                <section class="say-date-time">
                  <div class="mat-body-1 m-b-12">Say date and time</div>
                  <div>{{ voicemailFormGroup.controls.sayDateTime.value ? "Yes" : "No" }}</div>
                </section>
                <section class="say-duration">
                  <div class="mat-body-1 m-b-12">Say message duration</div>
                  <div>{{ voicemailFormGroup.controls.sayDuration.value ? "Yes" : "No" }}</div>
                </section>
                <section class="say-caller-id">
                  <div class="mat-body-1 m-b-12">Say Caller ID</div>
                  <div>{{ voicemailFormGroup.controls.sayCallerId.value ? "Yes" : "No" }}</div>
                </section>
                <section class="transfer-address">
                  <div class="mat-body-1 m-b-12">
                    {{ "ONSIP_I18N.PRESSING_ZERO_REDIRECTS_TO" | translate }}
                  </div>
                  <div>
                    {{
                      transferAddress
                        ? "(" +
                          (transferAddress.addressType | singularAddressType) +
                          ") " +
                          transferAddress.name
                        : "None"
                    }}
                  </div>
                </section>
                <section>
                  <div class="mat-body-1 m-b-12">Pager notification address</div>
                  <div>{{ voicemailFormGroup.controls.pagerNumber.value || "none" }}</div>
                </section>
                <section class="sip-address">
                  <div class="mat-subtitle-1">Voice mailbox applies to:</div>
                  <div class="mat-body-1 m-b-12">SIP address</div>
                  <div>{{ getSipAddress() }}</div>
                </section>
                <section class="extensions">
                  <div class="mat-body-1 m-b-12">Extension(s)</div>
                  @for (ext of voicemailFormGroup.controls.extensionsList.value; track ext) {
                  <div [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_REVIEW_EXTENSIONS">
                    <div>{{ ext }}</div>
                  </div>
                  } @if (voicemailFormGroup.controls.extensionsList.value.length === 0) {
                  <div>
                    {{ "ONSIP_I18N.NO_VALUES" | translate : { values: "extensions" } }}
                  </div>
                  }
                </section>
              </div>
            </div>
            } @if (showEditPanel) {
            <ng-template
              *ngTemplateOutlet="voicemailAdvancedForm; context: { $implicit: 'one-column' }"
            ></ng-template>
            }
          </div>
        </div>
        @if ((mobileBreakpoint | async) === false) {
        <div class="navigation-buttons">
          <button type="button" mat-stroked-button color="primary" (click)="backStep()">
            Back
          </button>
          <span>
            <button
              mat-button
              type="button"
              color="primary"
              class="cancel-button"
              (click)="handleCancel()"
            >
              Cancel
            </button>
            <button
              type="submit"
              mat-flat-button
              color="primary"
              matStepperNext
              [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_REVIEW_FINISH"
            >
              Save & finish setup
            </button>
          </span>
        </div>
        } @if (mobileBreakpoint | async) {
        <div class="navigation-mobile-buttons">
          <button
            type="submit"
            mat-flat-button
            color="primary"
            matStepperNext
            [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_REVIEW_FINISH"
          >
            Save & finish setup
          </button>
          <button type="button" mat-stroked-button color="primary" (click)="backStep()">
            Back
          </button>
          <button mat-button type="button" color="primary" (click)="handleCancel()">Cancel</button>
        </div>
        }
      </mat-step>
      <!-- ng-template needs to be inside the stepper for template to work-->
      <ng-template #voicemailBasicForm let-column>
        <div
          class="voicemail-basic-form-container {{ column }}"
          [ngClass]="{ 'onsip-grid-placement': !showEditPanel }"
        >
          <div class="first-column">
            <section class="mailbox-owner with-mat-form-field">
              <div class="mat-body-1 m-b-12">Mailbox owner</div>

              <onsip-address-autocomplete
                [addressTypes]="['user', 'group']"
                formControlName="mailboxOwner"
              >
              </onsip-address-autocomplete>
            </section>
            <section class="mailbox-name with-mat-form-field">
              <mat-form-field appearance="outline">
                <mat-label>Mailbox name</mat-label>
                <input
                  matInput
                  required
                  type="text"
                  formControlName="mailboxName"
                  [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_MAILBOX_NAME"
                />
                <mat-error>{{ getMailboxNameError() }}</mat-error>
              </mat-form-field>
            </section>
            <section class="with-mat-form-field">
              <mat-form-field appearance="outline">
                <mat-label>Mailbox number</mat-label>
                <input
                  matInput
                  required
                  type="text"
                  formControlName="mailboxNumber"
                  [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_ADD_MAILBOX_NUMBER"
                />
                <mat-error>{{ getMailboxNumberError() }}</mat-error>
              </mat-form-field>
            </section>
          </div>
          <div class="second-column">
            <section class="notification-email with-mat-form-field">
              <div class="mat-body-1 m-b-12">Notifications</div>
              <mat-form-field appearance="outline">
                <mat-label>Notification email</mat-label>
                <input matInput email type="text" formControlName="notificationEmail" />
                @if (voicemailFormGroup.controls.notificationEmail.errors?.email) {
                <mat-error>
                  {{ "ONSIP_I18N.MUST_BE_A_VALID_EMAIL_ADDRESS" | translate }}
                </mat-error>
                }
              </mat-form-field>
            </section>
            <section class="notification-checkboxes">
              <mat-checkbox formControlName="attachAsWav" color="primary">
                Attach message as a .wav file
              </mat-checkbox>
              <mat-checkbox formControlName="deleteAfterSending" color="primary">
                Delete message after sending
              </mat-checkbox>
            </section>
            <section class="mwi with-mat-form-field">
              <div class="mat-body-1 m-b-12">Message waiting notification</div>
              <onsip-address-autocomplete #address [addressTypes]="['user']" formControlName="mwi">
              </onsip-address-autocomplete>
            </section>
          </div>
        </div>
      </ng-template>
      <ng-template #voicemailGreetingForm let-column>
        <div
          class="voicemail-greeting-form-container {{ column }}"
          [ngClass]="{ 'onsip-grid-placement': !showEditPanel }"
        >
          <div class="first-column">
            <div>
              <div class="mat-body-2 descriptive-greeting-text">
                To record a greeting: click the microphone to start recording your voice for a
                personalized greeting. After you finish recording, you can review the greeting
              </div>
              <div class="mat-body-2 descriptive-greeting-text">
                To upload a greeting: upload a pre-recorded wav file
              </div>
            </div>
            <onsip-togglable-recorder
              formControlName="greeting"
              [hasSelect]="false"
              [defaultType]="greetingType"
              (recordingTypeChange)="greetingType = $event"
              (urlChange)="displayAudioFile = $event"
            >
            </onsip-togglable-recorder>
          </div>
        </div>
      </ng-template>
      <ng-template #voicemailAdvancedForm let-column>
        <div
          class="voicemail-advanced-form-container {{ column }}"
          [ngClass]="{ 'onsip-grid-placement ': !showEditPanel }"
        >
          <div class="first-column">
            <section class="time-zone with-mat-form-field">
              <div class="mat-body-1 m-b-12">Time zone</div>
              <mat-form-field appearance="outline">
                <mat-select formControlName="timezone">
                  @for (tz of timeZones; track tz) {
                  <mat-option [value]="tz[0]">
                    {{ tz[1] }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </section>
            <section class="say-date-time">
              <mat-checkbox color="primary" formControlName="sayDateTime">
                On playback say date and time
              </mat-checkbox>
            </section>
            <section class="say-duration">
              <mat-checkbox color="primary" formControlName="sayDuration">
                On playback say message duration
              </mat-checkbox>
            </section>
            <section class="say-caller-id">
              <mat-checkbox color="primary" formControlName="sayCallerId">
                On playback say Caller ID
              </mat-checkbox>
            </section>
            <section class="transfer-address with-mat-form-field">
              <div class="mat-body-1 m-b-12">
                {{ "ONSIP_I18N.PRESSING_ZERO_REDIRECTS_TO" | translate }}
              </div>
              <onsip-address-autocomplete
                [customOptions]="customOptions"
                noneSelectedMessage="None"
                formControlName="transferAddress"
              >
              </onsip-address-autocomplete>
            </section>
            <section class="with-mat-form-field">
              <div class="mat-body-1 m-b-12">Pager notification address</div>
              <mat-form-field appearance="outline">
                <input matInput formControlName="pagerNumber" />
                <mat-error>A pager must be in the email format; user&#64;domain</mat-error>
              </mat-form-field>
            </section>
          </div>
          <div class="second-column">
            <section class="sip-address with-mat-form-field">
              <div class="mat-subtitle-1">Voice mailbox applies to:</div>
              <div class="mat-body-1 m-b-12">SIP address</div>
              <onsip-sip-address-field formControlName="sipAddressUsername">
              </onsip-sip-address-field>
            </section>
            <section class="extensions">
              <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
              <onsip-extensions-list #extensionsList formControlName="extensionsList">
              </onsip-extensions-list>
            </section>
          </div>
        </div>
      </ng-template>
    </mat-horizontal-stepper>
  </form>
</onsip-loading-container>
<span class="mat-body-2 contact-support"
  >{{ "ONSIP_I18N.NEED_HELP_CONTACT_OUR" | translate }}
  <a class="support-link" [routerLink]="views.CONTACT_SUPPORT">
    {{ "ONSIP_I18N.SUPPORT_TEAM" | translate }}
  </a>
</span>
